import React, {Component} from 'react';
import EventImg from '../../assets/images/yoga.png';


export default class ResourcesPage extends Component{
    constructor(){
        super()

        this.data = ['Health' , 'Activities' , 'Fianance'];
    }

    render(){
        return(
            <div className="resources-main">
            <div className="container-fluid">
            <div className="resources-head">
            <h3>Partnerships</h3>
            <p>Things to help you along your care journey</p>
            </div>
            <div className="resources-list">

            {
                this.data.length>0 ?

                this.data.map((items,i)=>(


             
            <div className="row">
            <div className="col-md-12 col-lg-12">
            <div className="resources-list-head">
            <h5>{items}</h5>
            </div>
            </div>
            <div className="col-md-12 col-lg-12">
            <div className="resources-list-seperation">
            
            </div>
            </div>
            <div className="col-md-12 col-lg-12">
            <div className="resources-list-content">
            <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
            <div className="resources-list-content-card" onClick={()=>this.props.HandleRouting('partner-details')}>
            <div className="row">
            <div className="col-4 col-md-3 col-lg-3">
            <div className="resources-list-content-card-img">
            <img src={EventImg} alt="loading...."/>
            </div>
            </div>
            <div className="col-8 col-md-9 col-lg-9">
            <div className="resources-list-content-card-info">
            <h5>Likely</h5>
            <p>Hearing aids and doctor care deliver to your family.</p>
            </div>
            </div>
            </div>
            </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
            <div className="resources-list-content-card" onClick={()=>this.props.HandleRouting('partner-details')} >
            <div className="row">
            <div className="col-4 col-md-3 col-lg-3">
            <div className="resources-list-content-card-img">
            <img src={EventImg} alt="loading...."/>
            </div>
            </div>
            <div className="col-8 col-md-9 col-lg-9">
            <div className="resources-list-content-card-info">
            <h5>Likely</h5>
            <p>Hearing aids and doctor care deliver to your family.</p>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            </div>
            ))
        :''}
            </div>
            </div>
            </div>
        )
    }
}


